import { Component, OnInit } from "@angular/core";
import { authenticationService } from "src/app/Services/Authentication/authentication.service";
import { ViewController } from "@ionic/core";
import {
  PopoverController,
  ModalController,
  NavParams,
  ToastController,
} from "@ionic/angular";
import { SharedService } from "src/app/Services/sheared/sharedService.service";
import { Router } from "@angular/router";
import { CotationService } from "src/app/Services/Cotation/cotation.service";
import { FactoryService } from "src/app/Services/historique/factory.service";
import { isNullOrUndefined } from "util";

@Component({

  selector: "app-LivraisonComponent",
  templateUrl: "./Livraison.component.html",
  styleUrls: ["./Livraison.component.scss"],
})
export class LivraisonComponent implements OnInit {
  livrer: boolean = false;
  lieu: string;
  heure: number;
  montantLivraison:number
  constructor(
    private viewCtrl: PopoverController,
    private _router: Router,
    private modalcontroller: ModalController,
    private nvparms: NavParams,
    private toastctl: ToastController,
    private facto: FactoryService,

    private _cotationService: CotationService
  ) {
     this.montantLivraison = this.nvparms.get('value');

  }

  ngOnInit() {
    //this.isEnabled=false
  }

  async onCloseModal() {
    this.modalcontroller.dismiss();
    //this.facto.setData(50,"")
    // setTimeout(() => {
    //   this._router.navigate(['/home/cotation/formulaireauto'])
    // },300);
  }
  async onNext() {
  
  }
  onSelect(event) {
    if (event.target.value == "2") {
      this.livrer = true;
    } else {
      this.livrer = false;
    }
  }

  onValide() {
    if (this.livrer) {
      if ((isNullOrUndefined(this.lieu) || this.lieu == "")) {
        this.presentErreur();
      } else {
        if (this.heure>=9 && this.heure<=17) {
          this._cotationService.livrerObject.next({
            livrer: this.livrer ? this.montantLivraison : 0,
            lieu: this.lieu,
            heure: this.heure
          });
          this.modalcontroller.dismiss();
        }else{
          this.presentErreur()
        }
   
      }
    }else{
      this._cotationService.livrerObject.next({
        livrer:0,
        lieu: "",
        heure: 0
      });
      this.modalcontroller.dismiss();
    }
 

  }

  private async presentErreur() {
    const toast = await this.toastctl.create({
      animated: true,
     // closeButtonText: "Ok",
      // color: 'danger',
      //cssClass: 'toast-success',
      duration: 3000,
      header: "Attention erreur!!",
      keyboardClose: true,
      message:
        "Impossible de passer au paiement" +
        "<p><strong>*Vous avez choisi d'être livré,mais le lieu et l'heure ne sont pas précisés ou votre heure n'est pas convenable.Les livraisons commencent à 9h jusqu'à 18h</strong></p>",
      mode: "ios",
      position: "bottom",
      //showCloseButton: true,
      //translucent: true
    });
    toast.present();
  }
}
